module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-greek120.73dd50d.woff2";